import { useField } from 'formik'

import '../Inputs.scss'

const TextInput = ({ label, children, customOnBlur, ...props }: any) => {
  const [{ onBlur, ...field }, meta] = useField(props)

  const handleBlur = (event: React.FocusEvent<HTMLInputElement>) => {
    onBlur(event)
    customOnBlur && customOnBlur(field.value)
  }

  return (
    <>
      <div className={`text-input ${meta.touched && meta.error && 'error'}`}>
        <div className='text-input__label'>{label || ''}</div>
        <input
          className={`text-input__input ${label && 'with-label'}`}
          onBlur={handleBlur}
          {...props}
          {...field}
        />
        {children}
        {meta.touched && meta.error && (
          <div className='validation-error'>
            <div className='validation-error__icon'></div>
            {meta.error}
          </div>
        )}
      </div>
    </>
  )
}

export default TextInput
